import React from "react";

import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ChatHeader.module.css";

interface ChatHeaderProps {
  title: string;
  right?: React.ReactNode;
  left?: React.ReactNode;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ title, right, left }) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftSection}>{left}</div>
      <div className={styles.titleSection}>
        <Tooltip tooltipText={title} placement="top">
          <Text className={styles.title} variant="title2">
            {title}
          </Text>
        </Tooltip>
      </div>
      <div className={styles.rightSection}>{right}</div>
    </div>
  );
};

export default ChatHeader;
